<template>
<div class="chapter">
<div class="inner_page">
<p class="other"> </p>
<p class="other"> </p>
<p class="other"> </p>
<p class="other">Other Cathy<sup>®</sup> Books from Andrews McMeel Publishing</p>
<p class="other1">I Am Woman, Hear Me Snore<br/>
Abs of Steel, Buns of Cinnamon<br/>Understanding the “Why” Chromosome<br/>The Child Within Has Been Awakened But the Old Lady on the Outside Just Collapsed<br/>Revelations from a 45-Pound Purse<br/>Only Love Can Break a Heart, But a Shoe Sale Can Come Close<br/>$14 in the Bank and a $200 Face in My Purse<br/>My Granddaughter Has Fleas!!<br/>Why Do the Right Words Always Come Out of the Wrong Mouth?<br/>A Hand to Hold, an Opinion to Reject<br/>Thin Thighs in Thirty Years<br/>Wake Me Up When I’m a Size 5<br/>Men Should Come with Instruction Booklets<br/>A Mouthful of Breath Mints and No One to Kiss<br/>Another Saturday Night of Wild and Reckless Abandon</p>
<p class="other1">Cathy Twentieth Anniversary Collection<br/> Reflections: A Fifteenth Anniversary Collection</p>
<div class="float_img_left_1-4"><img alt="" src="images/img_0352.jpg"/></div>
<p class="other1">Confessions to My Mother<br/> Girl Food: Cathy’s Cookbook for the Well-Balanced Woman</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ISE_03.vue?1ff0c2b4